var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[(_vm.individualist_summary.length > 0)?_vm._l((_vm.individualist_summary),function(value,key){return _c('p',{key:key,staticClass:"base-body-text text-dark--text mb-8",class:{ 'font-weight-bold': key === 0 }},[_vm._v(" "+_vm._s(value)+" ")])}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }